import ajax from '../utils/axios'

// 问题类型列表
export const GetProblemList = (params) => ajax.get(`/index/problem/get_problem_list?limit=${params.limit}&page=${params.page}`)

// 新增问题类型
export const PostProblemAdd = (params) => ajax.post('/index/problem/add', params)

// 修改问题类型
export const PostProblemEdit = (params) => ajax.post('/index/problem/edit', params)

// // 问题类型详情
// export const GetUserList = (params) => ajax.get('/user/get_user_list', params)

